<template>
  <div class="myPage" id="myPage">
    <div class="title">マイページ</div>
    <MyPagePanel :panelList="menuList" @select="select"/>
  </div>
</template>

<script>
import MyPagePanel from '@/components/MyPagePanel';

export default {
  name: 'CastMyPageTop',
  components: {
    MyPagePanel
  },
  data() {
    return {
      menuList: [
        { menu: "castProfile", icon: "profile", name: "プロフィール", text: "プロフィールを確認・編集できます。", buttonText: "プロフィールを確認" },
        { menu: "liveSchedule", icon: "live_schedule", name: "配信予定管理", text: "配信予定を確認・編集できます。", buttonText: "配信予定管理" },
        { menu: "liveMenu", icon: "live_menu", name: "配信方法について", text: "配信の方法をご案内します。", buttonText: "配信方法について" },
        { menu: "profilePasswordReset", icon: "profile_password_reset", name: "パスワード再設定", text: "パスワードを再設定できます。", buttonText: "パスワード再設定" },
      ]
    };
  },
  methods: {
    select(menu) {
      this.$router.push('/cast/mypage/' + menu);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/myPageTop.scss';
</style>
